<template>
  <div>
    <v-select v-if="field.type=='select'"
              v-model="model"
              :items="field.options"
              :label="field.description"
    ></v-select>

    <v-select v-else-if="field.type=='fieldOrder'"
              v-model="model"
              :items="getFields()"
              :label="field.description"
              item-text="name"
              item-value="order"
    ></v-select>

    <v-select v-else-if="field.type=='fieldOrders'"
              v-model="model"
              :items="getFields()"
              :label="field.description"
              item-text="name"
              item-value="order"
              multiple
    ></v-select>

    <v-select v-else-if="field.type=='relatedFieldOrder'"
              v-model="model"
              :items="getFields('related')"
              :label="field.description"
              item-text="name"
              item-value="order"
    ></v-select>

    <v-select v-else-if="field.type=='teams'"
              v-model="model"
              :items="teams"
              :label="field.description"
              item-text="name"
              item-value="id"
              multiple
    ></v-select>

    <v-select v-else-if="field.type=='schemaId'"
              v-model="model"
              :items="schemas"
              :label="field.description"
              item-text="name"
              item-value="id"
              @change="$emit('schemaChanged',$event)"
    ></v-select>

    <v-select v-else-if="field.type=='foreignFieldOrder'"
              v-model="model"
              :items="foreignFields"
              :label="field.description"
              item-text="name"
              item-value="order"
    ></v-select>

    <v-select v-else-if="field.type=='tableFieldId'"
              v-model="model"
              :items="tableFields"
              :label="field.description"
              item-text="name"
              item-value="id"
    ></v-select>

    <v-select v-else-if="field.type=='radioTableFieldId'"
              v-model="model"
              :items="tableFields ? tableFields.filter(el => el.type = 'radio' && el.options.group): []"
              :label="field.description"
              item-text="name"
              item-value="id"
    ></v-select>


    <v-checkbox v-else-if="field.type=='checkbox'"
                v-model="model"
                :label="field.description"
    ></v-checkbox>

    <v-select v-else-if="field.type=='templateId'"
              v-model="model"
              :items="templates"
              :label="field.description"
              item-text="name"
              item-value="id"
    ></v-select>

    <v-menu v-else-if="field.type=='color'" offset-y>
      <template v-slot:activator="{ on }">
        <div></div>
        <v-text-field v-model="model" class="schema-name-input" label="Kolor"
                      v-on="on"></v-text-field>
      </template>

      <v-container style="background-color: #ffffff">
        <color-picker v-bind="model"
                      @input="(hue) => onInput(hue, hex => model = hex)"/>
      </v-container>
    </v-menu>

    <div v-else-if="field.type=='formMap'">
      <div v-if="foreignSchema && model != null">
        <v-select v-for="foreignField in getAllFields(foreignSchema.fields)"
                  v-model="model[foreignField.id]"
                  :items="getAllFields(schema.fields)"
                  :label="foreignField.name"
                  item-text="name"
                  item-value="id"
        ></v-select>
      </div>
    </div>

    <v-text-field v-else v-model="model" :label="field.description"
                  :type="getInputType(field.type)"></v-text-field>

  </div>

</template>

<script>
import Vue from "vue"
import ColorPicker from '@radial-color-picker/vue-color-picker'
import color from "@/mixins/color"

export default {
  mixins: [color],
  watch: {
    model: function (newVal) {
      this.$emit('input', newVal)
    }
  },
  components: {ColorPicker},
  props: ['elementTypes', 'schema', 'schemas', 'templates', 'value', 'field', 'foreignSchema'],
  data() {
    return {
      model: null
    }
  },
  computed: {
    teams() {
      return this.$store.state.teams
    },
    foreignFields() {
      if (!this.foreignSchema || this.foreignSchema == undefined) {
        return []
      }

      return this.getFields(false, this.foreignSchema.fields)
    },
    tableFields() {
      if (this.schema)
        return this.getTableFields(this.schema.fields)
      else
        return []
    },
    fields() {
      return this.getAllFields(this.schemaFields)
    }
  },
  created() {
    if (this.field.type == 'formMap') {
      this.model = {}
    }
  },
  methods: {
    getFieldLength(field) {
      return field.length
    },
    getFields(type, fields) {
      let fieldsToFilter = fields != undefined ? fields : this.schema.fields
      return fieldsToFilter.filter(field => field.type != 'table' && type ? field.type == type : true)
    },
    getAllFields(fieldsToFilter) {
      let fields = []
      fieldsToFilter.forEach(field => {
        fields.push(field)
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    },
    getTableFields(fieldsToFilter) {
      let fields = []
      fieldsToFilter.forEach(field => {
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    },
    getInputType(type) {
      switch (type) {
      case "integer" :
        return "number"
      case "relatedValueKey" :
        return "number"
      default :
        return "text"
      }
    },
    addSubFieldsForMultiField(field) {
      if (this.model[field.name] == undefined) {
        this.model[field.name] = []
        Vue.set(field, "length", 0)
      }

      let obj = {}
      field.options.subFields.forEach(sf => obj[sf.name] = "")
      this.model[field.name].push(obj)
      Vue.set(field, "length", field.length + 1)
    },
    removeSubFieldsForMultiField(field) {
      if (this.model[field.name] != undefined) {
        this.model[field.name].splice(-1)
        Vue.set(field, "length", field.length - 1)
      }
    },
  }
}
</script>

<style scoped>

</style>